(function($, undefined) {
	"use strict";
	
	function init() {
		$('.wizard-save-and-exit__cancel').on('click', onCancelSaveAndExit);
		$('.wizard-save-and-exit__save').on('click', onSaveAndExit);
		$('.wizard__btn_prev').on('click', onPrevClick);
		$('.wizard-users-access__select').on('change', onWizardUsersListChange);
		$('body').on('location-user-removed', (e, personId, name, roleText, parent) => {
			reAddExistingUserInSelect(personId, name, roleText, parent);
		});
	}

	function onSaveAndExit() {
		$('.wizard__questions').append('<input type="hidden" name="save" value="true"/>');
		$('.wizard__questions').submit();
	}

	function onCancelSaveAndExit() {
		$('.save-and-exit-popup').removeClass('visible');
	}

	function onPrevClick() {
		let form = $('.wizard__questions');
		form.append('<input type="hidden" name="previous" value="true" />');
		form.get(0).submit();
	}

	function onWizardUsersListChange({ currentTarget }) {
		let t = $(currentTarget);
		let selectedOption = $('option:selected', t);

		let personId = t.val();
		let name = selectedOption.text().split(" - ")[0];
		let email = selectedOption.text().split(" - ")[1];
		let newUsersList = $(`#${t.attr('data-id')}`);
		
		appendNewUserItem(name, email, personId, newUsersList);
		selectedOption.remove();
	}

	function reAddExistingUserInSelect(personId, name, email, parent) {
		let selectName = parent.length == 0 ? 'wizard-users' : parent.attr('data-select');
		let option = `<option value="${personId}">${name} - ${email}</option>`;
		$(`select[name="${selectName}"]`).append(option);
	}

	function appendNewUserItem(name, email, personId, newUsersList) {
		let item = $('.location-form-editable-list-item.template', newUsersList).clone(true);
		let deleteItem = item.find('.location-form-editable-list-item__btn_delete');
		let content = $('.location-form-editable-list-item__content', item);

		deleteItem.attr("data-item-id", personId);
		deleteItem.attr("data-name", name);
		deleteItem.attr("data-role-text", email);

		item.removeClass("template");
		item.attr("data-id", "location-editable-item-" + personId);
		item.attr("data-item-id", personId);

		content.find("strong").text(name);
		content.find("span").text(email);

		newUsersList.append(item);
	}
	
	$(init);
	
})(jQuery);